import React, { ChangeEvent, FC, useState } from 'react';
import { FormControlLabel, Grid, Radio, RadioGroup, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { PostSource, SearchContentInput } from 'api';

interface Props {
  filter: SearchContentInput;
  setFilter: (filter: SearchContentInput) => void;
}

enum SourceParams {
  User = 'user',
  External = 'external',
  All = 'all',
}

const Source: FC<Props> = ({ filter, setFilter }) => {
  const { t } = useTranslation();

  const [radioValue, setRadioValue] = useState(filter.source || SourceParams.All);

  function onChangeSource(event: ChangeEvent<HTMLInputElement>) {
    const { value } = event.target;
    setRadioValue(value as SourceParams);

    if (value === SourceParams.All) {
      delete filter.source;
      setFilter({ ...filter });
      return;
    }

    setFilter({
      ...filter,
      source: value === SourceParams.User ? PostSource.User : PostSource.External,
    });
  }

  return (
    <Grid item container alignItems="center">
      <Grid item xs={3}>
        <Typography variant="body2">{t('common:source')}</Typography>
      </Grid>
      <Grid item xs={8} container justify="flex-start">
        <RadioGroup row onChange={onChangeSource} defaultValue="all" value={radioValue}>
          <FormControlLabel
            control={<Radio color="primary" />}
            label={t('common:user')}
            value={SourceParams.User}
            color="primary"
          />
          <FormControlLabel
            control={<Radio color="primary" />}
            label={t('common:external')}
            value={SourceParams.External}
            color="primary"
          />
          <FormControlLabel
            control={<Radio color="primary" />}
            label={t('common:all')}
            value={SourceParams.All}
            color="primary"
          />
        </RadioGroup>
      </Grid>
    </Grid>
  );
};

export default Source;
